var dirtyURL = $("#logo").attr('href');
var cleanURL = dirtyURL.split("/")
if(cleanURL[cleanURL.length - 1] != "") {
    cleanURL.pop();
    cleanURL = cleanURL.join('/');
} else {
    cleanURL.pop();
    cleanURL.pop();
    cleanURL = cleanURL.join('/');
}

self.debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);
    };
}

if (typeof window.chatIcons !== "function") {
    window.chatIcons = function (value, row) {
        if (value) {
            return '<div class="buttons-wrap chats"><i class="svg chat chat-unreaded">' +
                '<img src="' + cleanURL + '/images/svg/chat.svg"/>' +
                '</i></div>';
        } else {
            return '<div class="buttons-wrap chats"><i class="svg chat">' +
                '<img src="' + cleanURL + '/images/svg/chat.svg"/>' +
                '</i></div>';
        }
    }
}

if (typeof window.rowStyle !== "function") {
    window.rowStyle = function (row, index) {

        var isRed = "";
        var isGreen = "";
        if (row.is_red) {
            isRed = "red-rows";
        }
        if (row.is_green) {
            isGreen = "green-rows";
        }
        return {
            classes: isRed + isGreen
        };
    }
}



if (typeof window.linkFormatter !== "function") {
    window.linkFormatter = function (value, row) {
        if (value == null) {
            return '<a href="./orders/' + row.id + '" class="forward-link" tabindex="-1">' +
                '-' +
                '</a>';
        }
        return '<a href="./orders/' + row.id + '" class="forward-link" tabindex="-1">' +
            value +
            '</a>';
    }
}

if (typeof window.inlineEdit !== "function") {
    window.inlineEdit = function (value, row) {
//        if (value == null) {
//            return '<a href="./orders/' + row.id + '" class="forward-link">' +
//                '-' +
//                '</a>';
//        }
        var html = '<a id="edit_' + row.id +'" href="#" class="editable editable-click" data-type="text" data-name="patient" data-pk="' + row.id + '" data-url="' + '/updateUrl' + '" data-emptytext="..." data-title="' + value + '">' +
            value +
            '</a>';
//        $(document).ready(function () {
//            $('#edit_' + row.id).editable({
//                success: function (response, newValue) {
//                    //if(response.status == 'error') return response.msg;
//                },
//                error: function (response, newValue) {
////                                    if(response.status == 'error') return response.msg;
//                },
//            });
//        });
        return html;    
            
    }
}

if (typeof window.inlineEditText !== "function") {
    window.inlineEditText = function (value, row) {
        //console.log($(this)[0].field);
        if(value == null) {
            value = '';
        }
        
        return '<input id="edit_' + $(this)[0].field +'_' + row.id +'" name="'+ $(this)[0].field +'" class="inline-edit inline-edit-text text-field ml-1" data-pk="' + row.id + '" value="' + value + '">';
    }
}

if (typeof window.inlineEditSelect !== "function") {
    window.inlineEditSelect = function (value, row) {
        if(value == null) {
            value = '';
        }
        
        return '<select id="edit_' + this.dataType + '_' + $(this)[0].field +'_' + row.id +'" class="text-field flex-1 inline-edit inline-edit-select" name="'+ $(this)[0].field +'" data-pk="' + row.id + '" required>' +
            '<option value="' + value  + '" selected>' + value + '</option>' +
        '</select>';
    }
}


if (typeof window.shipmentQueryParams !== "function") {
    window.shipmentQueryParams = function shipmentQueryParams(params) {
        var curShipFilter = $('.ship-date-filter.active');

        if (curShipFilter !== undefined) {
            params.shippedDate = curShipFilter.data('ship');
            params.deliveryDate = curShipFilter.data('delivery');
        }

        return params;
    }
}


function OrderTable(el) {
    this.el = el;
    this.documentsData = '';
    this.orderTable = this.el.find('.custom-order-table');
    this.previewBox = this.el.find('.preview-box');
    this.dataType = this.el.attr('data-type');
    this.divToPrint = $('#divIdToPrint');
    this.el.find('.dropdown-menu').prepend('<span class="show-cols">Columns to be shown</span>');
    this.previewSidebarDetails = this.el.find('[preview-sidebar-details]');


    if (!this.previewBox.length) {
        if (this.orderTable.find('tbody').height() + 228 < window.innerHeight) {
            this.el.closest('.orders-vh-content').addClass('orders-max-vh-content');
        }
    }

    setTimeout(() => {
        this.customTable(this);
        this.bindEvents();
        this.customSearch();
    }, 0);

}

OrderTable.prototype = {

    customSearch: function () {
        var $search = $('.fixed-table-toolbar .search input');
        $search.attr('placeholder', 'Søk i ordre');
    },
    reBuildTable: function () {
     
    },

    customTable: function (obj) {

    },

    bindEvents: function () {
        var obj = this;
        var activeIndex = 0;
        var activeRow = '';
        var checkedRows = [];

        function selectRow(e) {
            e.stopPropagation();
            selectRowDebFn(e);
        }

        var selectRowDebFn = debounce(function (e) {
            if (e.which != 38 && e.which != 40) {
                return
            }
            if ((!obj.el.closest('.tab-pane').hasClass('show') && obj.previewBox.length)) {
                return;
            }
            switch (e.which) {
                case 38:
                    activeRow = obj.orderTable.find('tr.active');
                    if (activeRow.prev().length) {
                        activeRow.removeClass('active');
                        setTimeout(function () {
                            activeRow.prev().addClass('active');
                        }, 0);
                    }

                    break;
                case 40: // down

                    activeRow = obj.orderTable.find('tr.active');
                    if (activeRow.next().length) {
                        activeRow.removeClass('active');
                        setTimeout(function () {
                            activeRow.next().addClass('active');
                        }, 0);
                    }

                    break;
            }

            if (!obj.previewBox.length) {
                return
            }
            setTimeout(function () {
                activeIndex = obj.orderTable.find('tbody').find('tr.active').attr('data_id');
                obj.updateDocumentsPreview(activeIndex);
            }, 0);
        }, 250);


        $(window).keydown(selectRow);

        obj.orderTable.on('load-success.bs.table', function (e, rows) {
            var orderId = $(obj.orderTable.find('tbody').find('tr')[0]).attr('data_id');
            $(obj.orderTable.find('tbody').find('tr')[0]).addClass('active');

            obj.updateDocumentsPreview(orderId);
            obj.initInlineEditSelect2();
        });

        obj.orderTable.on('column-switch.bs.table', function (e, rows) {
            obj.initInlineEditSelect2();
        });

        obj.orderTable.on('focusin', '.select2', function (e) {
            var parentTr = $(this).closest('tr');
            if(!parentTr.hasClass('active')) {
                parentTr.trigger($.Event('click-row.bs.table'), [e, parentTr, parentTr]);
            }
        });

        obj.orderTable.on('click-row.bs.table', function (row, $element, field) {
            var clickedId = field.attr('data_id');
            obj.orderTable.find('tbody').find('tr').removeClass('active');
            field.addClass('active');

            obj.updateDocumentsPreview(clickedId);
            
        });
        
        obj.orderTable.on("change",".inline-edit",function() {            
            $("#ajax-loader").fadeIn();
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: "POST",
                url: dirtyURL + "/orders/update",
                dataType: 'json',
                data: {'order_id': $(this).data('pk'), 'name': $(this).attr('name'), 'value': $(this).val() },
                success: function (res) {
                    $("#ajax-loader").fadeOut();
                },
                error: function (msg) {
                    console.log('error');
                    console.log(msg);
                    $("#ajax-loader").fadeOut();
                }
            });
        });

        obj.orderTable.on('pre-body.bs.table', function () {
            obj.reBuildTable();
        });

        window.addEventListener('bsTableOrdersRefresh', event => {
             obj.orderTable.bootstrapTable('refresh');
        });
        
        obj.orderTable.on('check-all.bs.table', function (e, rows) {
            checkedRows = rows.map((itm)=> {
                return {id: Number(itm.id), name: itm.name, forks: itm.forks}
            });
        });

        obj.orderTable.on('uncheck-all.bs.table', function (e, rows) {
            checkedRows = [];
        });
        
        obj.orderTable.on('check.bs.table', function (e, row) {
            checkedRows.push({id: Number(row.id), name: row.name, forks: row.forks});

            if ($(this).find('tr').hasClass('selected')) {
                $(this).find('tr').addClass('vis-checkbox');
                obj.el.siblings(".table-toolbar").find('.btns-box').addClass('vis-box');
            }
        });

        obj.orderTable.on('uncheck.bs.table', function (e, row) {
            $.each(checkedRows, function (index, value) {
                if (!value) {
                    return;
                }
                if (value.id === row.id) {
                    checkedRows.splice(index, 1);
                }
            });
            if (!$(this).find('tr').hasClass('selected')) {
                $(this).find('tr').removeClass('vis-checkbox');
                obj.el.siblings(".table-toolbar").find('.btns-box').removeClass('vis-box');
            }
        });

        var deleteRequest = function (val) {
            return confirm('This will delete ' + val + ' rows. Do you want to continue?');
        }

        obj.el.siblings(".table-toolbar").find('.btn-delete-row').on('click', (event) => {
            if (!deleteRequest(checkedRows.length)) {
                return
            }
            $.each(checkedRows, function (index, value) {
                obj.orderTable.bootstrapTable('removeByUniqueId', value.id);
            });
            event.preventDefault();
        });

        obj.el.siblings(".table-toolbar").find('.upload-zooze-btn').on('click', (event) => {
            event.preventDefault();
            checkedRows.forEach((value, index) => {
                $('#row-' + Number(value.id)).find('.buttons-wrap').toggleClass('visible-snooze');
            });
        });

        // print-documents
        $('.print-documents-btn').on('click', (event) => {
            this.updateDocumentsPrintPreview(checkedRows);
            event.preventDefault();
        });

        obj.orderTable.on('check-all.bs.table', function () {  // if have some troubles, we have to use this event: 'all.bs.table'
            $(this).find('tr').addClass('vis-checkbox');
            $('.btns-box').addClass('vis-box');
        });

        obj.orderTable.on('uncheck-all.bs.table', function () {  // if have some troubles, we have to use this event: 'all.bs.table'
            $(this).find('tr').removeClass('vis-checkbox');
            $('.btns-box').removeClass('vis-box');
            obj.divToPrint.html('');
        });

        obj.el.find('.expand-btn').on('click', function (event) {
            obj.el.addClass('collapse-preview-box');
            obj.el.find('.hide-collapse').fadeOut(250, function () {
                obj.el.find('.expand-preview').fadeIn();
            });
            obj.el.find('.expand-preview').on('click', function (event) {
                obj.el.removeClass('collapse-preview-box');
                $(this).fadeOut(100);
                obj.el.find('.hide-collapse').fadeIn(250);
            });
        });

        $('a[href="#' + obj.el.closest('.tab-pane').attr('id') + '"]').on('shown.bs.tab', (e) => {
            obj.reBuildTable();

            obj.orderTable.bootstrapTable('refresh', {
                url:  this.orderTable.attr('data-url-refresh') 
            });

            obj.initInlineEditSelect2();
        });

        // =======================================================
       //  Shipping date filter
        $(".package-info").find(".arrow-btn.prev-btn").on('click', {docData: this}, function (e) {

        if ($(this).hasClass('disabled')) {
            return;
        }
        if (!$(this).hasClass('disabled')) {
            $(".ship-date-filter.active").prev(".ship-date-filter").addClass("active");
            $(".ship-date-filter.active").next(".ship-date-filter").removeClass("active");
        }
        if ($(".ship-date-filter.active").next().hasClass('ship-date-filter')) {
            $(".package-info").find(".arrow-btn.next-btn").removeClass('disabled');
        } else {
            $(".package-info").find(".arrow-btn.next-btn").addClass('disabled');
        }
        if ($(".ship-date-filter").first().hasClass('active')) {
            $(".package-info").find(".arrow-btn.prev-btn").addClass('disabled');
        }

        var shippingDate = $(".ship-date-filter.active").data("ship");
        var deliveryDate = $(".ship-date-filter.active").data("delivery");
        $("#ajax-loader").fadeIn();
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'POST',
            url: currentURLBase + '/get-shipped-orders',
            data: {'shippedDate': shippingDate, 'deliveryDate': deliveryDate},
            success: function (response) {
                $("#ajax-loader").fadeOut();
                //Assign value to datatable 
                obj.orderTable.bootstrapTable('load', response);
                $(".data-count").text(obj.orderTable.bootstrapTable('getData').length);
                e.data.docData.initInlineEditSelect2();
            },
            error: function () {
                $("#ajax-loader").fadeOut();
            }
        });
    });



        $(".package-info").find(".arrow-btn.next-btn").on('click', {docData: this}, function (e) {
            if ($(this).hasClass('disabled')) {
                return;
            }
            if (!$(this).hasClass('disabled')) {
                $(".ship-date-filter.active").next(".ship-date-filter").addClass("active");
                $(".ship-date-filter.active").prev(".ship-date-filter").removeClass("active");
            }

            if ($(".ship-date-filter.active").prev().hasClass('ship-date-filter')) {
                $(".package-info").find(".arrow-btn.prev-btn").removeClass('disabled');
            } else {
                $(".package-info").find(".arrow-btn.prev-btn").addClass('disabled');
            }

            if ($(".ship-date-filter").last().hasClass('active')) {
                $(".package-info").find(".arrow-btn.next-btn").addClass('disabled');
            }

            var shippingDate = $(".ship-date-filter.active").data("ship");
            var deliveryDate = $(".ship-date-filter.active").data("delivery");
            $("#ajax-loader").fadeIn();
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: 'POST',
                url: '/admin/get-shipped-orders',
                data: {'shippedDate': shippingDate, 'deliveryDate': deliveryDate},
                success: function (response) {
                    $("#ajax-loader").fadeOut();
                    //Assign value to datatable 
                    obj.orderTable.bootstrapTable('load', response);
                    $(".data-count").text(obj.orderTable.bootstrapTable('getData').length);
                    e.data.docData.initInlineEditSelect2();
                },
                error: function () {
                    $("#ajax-loader").fadeOut();
                }
            });
        });

    },

    updateDocumentsPreview: function (orderId) {
        if(orderId) {
            Livewire.emit(`${this.dataType}_document_preiview`, orderId);
        }

        if(this.previewSidebarDetails.length && orderId) {
            Livewire.emit(`${this.dataType}_set_default_order_details`, orderId);
        }   
    },

    updateDocumentsPrintPreview: function (rows) {
        let ids = rows.map(itm=>itm.id);
        Livewire.emit(`get_documents_list_for_print`, ids);
    },  

    initInlineEditSelect2: function() {
        setTimeout(()=> {
            this.orderTable.find(".inline-edit-select").select2({
                ajax: {
                    url: "/dentist-list",
                    dataType: 'json',
                    data: function (params) {
                        return {
                            q: params.term, // search term
                            page: params.page
                        };
                    },
                    processResults: function (data, params) {
                        // parse the results into the format expected by Select2
                        // since we are using custom formatting functions we do not need to
                        // alter the remote JSON data, except to indicate that infinite
                        // scrolling can be used
                        params.page = params.page || 1;
                        return {
                            results: data.items,
                            pagination: {
                                more: (params.page * 10) < data.total_count
                            }
                        };
                    },
                    cache: true
                },
                placeholder: 'Select Dentist',
                escapeMarkup: function (markup) {
                    return markup;
                },
                dropdownParent: $('#content'),
            });
            $('input[type=checkbox]').each(function(idx, ele){
                $(ele).attr('tabindex', '-1');
            });
        }, 0);
    }

}
export default OrderTable;